import { buildInteractorDirectAction, buildInteractorDirectActionNoParams } from './base';
import { userActions } from '../slices/userSlice';

export const loginUserInteractor = buildInteractorDirectAction(userActions.login);
export const logoutUserInteractor = buildInteractorDirectActionNoParams(userActions.logout);
export const profileUserInteractor = buildInteractorDirectAction(userActions.profile);
export const saveProtocolInteractor = buildInteractorDirectAction(userActions.saveProtocol);
export const unsaveProtocolInteractor = buildInteractorDirectAction(userActions.unsaveProtocol);
export const redirectUserInteractor = buildInteractorDirectAction(userActions.redirect);
